
let _ = require('../_.js');
let $ = jQuery;

_.Notification_Bid_Denied = class Notification_Bid_Denied {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    static _denied_modal_init = false;
    static _denied_modal_action = null;

    // auction_round_id, bid_id, is_tie_bid = false) {
    async on_show() {
        let meta;
        let bid_id = null;

        try {
            meta = JSON.parse(this.notification.meta)
            if (meta.bid_id) {
                bid_id = meta.bid_id;
            }

        } catch (e) {
        }

        // Called when we receive a message from the server that the user has been denied on an item in this auction.
        // This is a notification - when the function returns, we will assume the notification has been satasfied.
        // So don't return the notification until we are done with the prompt.

        // See await _.Modal.pick().  Used for editing a pending bid.  may work better.

        // Button handlers.
        if (!_.Notification_Bid_Denied._denied_modal_init) {
            _.Notification_Bid_Denied._denied_modal_init = true;
            _.on_ui_update_once("#ac-modal-bid-denied-btn-bid-chat", function () {
                $(this).click(function () {
                    _.Notification_Bid_Denied._denied_modal_action = 'chat';
                    _.Modal.close_unhidable({ hide_overlay: false });
                })
            });
            _.on_ui_update_once("#ac-modal-bid-denied-btn-bid-custom", function () {
                $(this).click(function () {
                    _.Notification_Bid_Denied._denied_modal_action = 'custom';
                    _.Modal.close_unhidable({ hide_overlay: false });
                })
            });
            _.on_ui_update_once("#ac-modal-bid-denied-btn-close", function () {
                $(this).click(function () {
                    _.Modal.close_unhidable();
                })
            });
        }

        // The modal itself.
        // Call resolve when we are done here.
        await new Promise(function (resolve, reject) {
            (async function () {
                // do {
                _.Notification_Bid_Denied._denied_modal_action = null;

                let my_bid = await App_Models_Bid.get_private(bid_id);

                if (!my_bid) {
                    _.shouldnt_happen();
                    return;
                }

                $(".ac-modal-bid-denied-mybid").text(_.currency(my_bid.amount));

                let item = null;

                if (_.AuctionUI.auction_is_standard_or_enterprise()) {
                    $(".ac-modal-bid-denied-myitem-on-text").show();
                    $(".ac-modal-bid-denied-myitem").show();

                    let round = await my_bid.auction_round.fetch_private();
                    if (round) {
                        item = await round.auction_item.fetch_private();
                    }

                    $(".ac-modal-bid-denied-myitem").text(item.title);
                } else {
                    $(".ac-modal-bid-denied-myitem-on-text").hide();
                    $(".ac-modal-bid-denied-myitem").hide();

                    // Choice
                }


                if (my_bid.reason && my_bid.reason.trim() != 'None Given') {
                    $(".ac-modal-bid-denied-explanation-1").show();
                    $(".ac-modal-bid-denied-explanation-2").show().html(_.escape_multiline_string(my_bid.reason));
                } else {
                    $(".ac-modal-bid-denied-explanation-1").hide();
                    $(".ac-modal-bid-denied-explanation-2").hide();
                }

                let deferred = $.Deferred();

                $("#ac-modal-bid-denied").data('deferred', deferred);

                $("#ac-modal-bid-denied").modal_show();

                // Wait for the modal to close.
                await deferred.promise();

                // If they clicked a relevant button, handle it
                if (_.Notification_Bid_Denied._denied_modal_action == 'chat') {
                    await _.AuctionUI_Chat.chat_show();
                } else if (_.Notification_Bid_Denied._denied_modal_action == 'custom') {
                    await _.AuctionUI_Bids.custom_bid_modal(item ? item.id : null);
                }

                resolve();
            })();
        });

        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }

    async on_update() {
        // Update related data about the notification in real time.
    }

    async on_hide() {
    }
}